{#if isFigurine($textType) && pieceIconName}
  <span
    class={`${MoveListShared.Classes.IconFont} ${pieceIconName}-${color} ${figurineClassName}`}
    data-figurine="{san[0]}"/>
  {formatText({ san, translations: $translations, showFigurine: true, annotation })}
{:else}
  {formatText({ san, translations: $translations, annotation })}
{/if}

<script lang="ts">
import type { Data } from 'src/utils/svelte/data';
import type { Board } from 'chessboard/model/board/types';
import { formatText, getPieceIconNameFromSan } from 'components/move-list/helpers';
import { MoveListShared } from 'components/move-list-shared/config/types';
import type { Game } from 'chessboard/model/game/types';
import { getContext } from 'svelte';
import { MoveListPlugin } from 'chessboard/plugins/move-list/config/types';
import type { ContextShape } from '../store/types';

export let color: Game.ColorsAsWords;
export let san: string;
export let textType: Data<Board.MoveListDisplayTypes>;
export let annotation: string | undefined = '';
export let figurineClassName: string | undefined = '';

const { store } = getContext<ContextShape>(MoveListPlugin.Name);
const { translations } = store;

const isFigurine = (textDisplayType: Board.MoveListDisplayTypes) => textDisplayType === 'figurine';

$: pieceIconName = getPieceIconNameFromSan(san);
</script>
